import React, { useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";

// Trang hướng dẫn nghiệp vụ Văn thư lưu trữ.
// Nội dung được xây dựng từ src/van-thu-luu-tru/HUONG_DAN_SU_DUNG.md.

const statusList = [
  { code: "0", name: "Đã gửi chờ chấp thuận", desc: "Trạng thái chờ phê duyệt quản lý trong luồng cũ hoặc luồng có quản lý.", color: "#6c757d" },
  { code: "1", name: "Chờ cấp số", desc: "Yêu cầu đã sẵn sàng để người cấp số xử lý.", color: "#f0a500" },
  { code: "2", name: "Đã cấp số chờ gửi file Scan", desc: "Người cấp số đã cấp số, người xin số cần upload bản scan.", color: "#17a2b8" },
  { code: "3", name: "Đã gửi file scan chờ phê duyệt", desc: "Người xin số đã upload file scan, người cấp số cần xác nhận.", color: "#007bff" },
  { code: "4", name: "Hoàn tất việc cấp số", desc: "Quy trình đã hoàn tất.", color: "#28a745" },
  { code: "5", name: "Quản lý từ chối duyệt", desc: "Bị từ chối ở bước quản lý, người xin số có thể chỉnh sửa và gửi lại.", color: "#dc3545" },
  { code: "6", name: "Bị từ chối cấp số", desc: "Bị người cấp số từ chối ở bước cấp số, người xin số có thể chỉnh sửa và gửi lại.", color: "#dc3545" },
  { code: "7", name: "File scan bị từ chối", desc: "File scan bị từ chối, người xin số upload lại và gửi lại.", color: "#dc3545" },
];

const chucNang = [
  { group: "Danh sách văn thư", link: "/van-thu", desc: "Xem danh sách, lọc, xem thống kê nhanh, mở chi tiết văn thư." },
  { group: "Thêm mới văn thư", link: "/add-van-thu", desc: "Tạo yêu cầu xin số văn thư." },
  { group: "Cập nhật, phê duyệt văn thư", link: "/van-thu", desc: "Cấp số, từ chối, upload scan, duyệt scan, phân quyền tiếp cận. (mở từ chi tiết văn thư)" },
  { group: "Xuất Excel", link: "/export-van-thu", desc: "Xuất file Excel danh sách văn thư." },
  { group: "Phân loại văn thư", link: "/vanthu_param", desc: "Cấu hình loại văn thư, cấu trúc mã, cấu trúc file, người cấp số." },
  { group: "Phân công cấp số", link: "/phan-cong-cap-so", desc: "Gán người cấp số văn thư cho từng phòng ban." },
];

const vaiTro = [
  { role: "Người xin số", work: "Tạo văn thư, theo dõi trạng thái, upload file scan khi đã được cấp số, gửi lại khi bị từ chối." },
  { role: "Người cấp số", work: "Kiểm tra yêu cầu, nhập số văn thư, chấp thuận hoặc từ chối, duyệt file scan để hoàn tất." },
  { role: "Người quản trị cấu hình", work: "Tạo loại văn thư, cấu trúc mã/file, gán người cấp số cho phòng ban." },
  { role: "Người được chia sẻ văn thư riêng tư", work: "Xem văn thư riêng tư sau khi được cấp quyền tiếp cận." },
];

const bienCauTruc = [
  { v: "[stt]", m: "Số thứ tự văn bản." },
  { v: "[year]", m: "Năm tài chính." },
  { v: "[type]", m: "Loại văn bản." },
  { v: "[type_p]", m: "Loại văn bản đính kèm." },
  { v: "[mpb]", m: "Mã phòng ban hành." },
  { v: "[mct]", m: "Mã công ty." },
  { v: "[msnv]", m: "Mã nhân viên." },
  { v: "[title]", m: "Tên nội dung văn bản." },
  { v: "[nk]", m: "Người ký." },
];

// Các quy trình nghiệp vụ - hiển thị dạng accordion
const quyTrinh = [
  {
    id: "qt1",
    title: "Quy trình 1: Cấu hình loại văn thư",
    intro: "Dùng khi cần tạo hoặc cập nhật loại văn thư (quyết định, thông báo, biên bản, công văn).",
    links: [
      { label: "Danh sách loại văn thư", to: "/vanthu_param" },
    ],
    steps: [
      "Vào menu Dịch vụ hành chính > Phân loại văn thư.",
      "Tạo mới hoặc mở một loại văn thư đã có.",
      "Nhập Tên loại văn thư và Mã.",
      "Chọn Đối tượng cấp số: Cá nhân / Phòng hành chính BHS / Phòng nhân sự BHS / Phòng pháp chế BHS / Phòng ban khác / Người xin số.",
      "Nếu chọn Cá nhân: chọn thêm nhân sự ở ô Chọn cá nhân.",
      "Nếu chọn Phòng ban khác: chọn thêm phòng ban ở ô Chọn phòng ban.",
      "Nếu chỉ áp dụng cho một công ty/phòng ban cụ thể thì chọn ở các ô tương ứng. Để trống = áp dụng tất cả.",
      "Nhập Cấu trúc mã và Cấu trúc file (dùng các biến bên dưới).",
      "Bấm Lưu lại.",
    ],
    image: "/huong-dan-van-thu/phan-loai.png",
    caption: "Màn hình danh sách loại văn thư: ① ô tìm kiếm, ② nút thêm loại mới.",
  },
  {
    id: "qt2",
    title: "Quy trình 2: Phân công người cấp số theo phòng ban",
    intro: "Gán nhân sự phụ trách cấp số văn thư cho từng phòng ban.",
    links: [{ label: "Phân công cấp số", to: "/phan-cong-cap-so" }],
    steps: [
      "Vào menu Dịch vụ hành chính > Phân công cấp số.",
      "Tìm phòng ban cần cấu hình bằng ô Tìm kiếm.",
      "Mở chi tiết phòng ban.",
      "Các trường Tên phòng ban, Tên rút gọn, Công ty, Trạng thái chỉ để xem (bị khoá).",
      "Chọn Người cấp số văn thư (danh sách lọc theo phòng ban đang mở).",
      "Bấm Lưu lại.",
    ],
    note: "Kết quả cấu hình này được dùng khi loại văn thư có đối tượng cấp số là phòng hành chính / nhân sự / pháp chế / phòng ban khác.",
    image: "/huong-dan-van-thu/phan-cong.png",
    caption: "Màn hình phân công cấp số: ① tìm phòng ban cần cấu hình rồi mở chi tiết để chọn người cấp số.",
  },
  {
    id: "qt3",
    title: "Quy trình 3: Người xin số tạo văn thư",
    intro: "Tạo yêu cầu đăng ký lấy số văn thư.",
    links: [{ label: "Thêm mới văn thư", to: "/add-van-thu" }],
    steps: [
      "Vào Dịch vụ hành chính > Văn thư lưu trữ > bấm thêm mới.",
      "Nhập Tiêu đề.",
      "Kiểm tra thông tin người xin số, mã nhân viên, phòng ban và công ty.",
      "Chọn Công ty nếu cần thay đổi công ty áp dụng.",
      "Chọn Loại văn thư — hệ thống tự tính người cấp số theo cấu hình loại văn thư.",
      "Nếu loại văn thư cần chọn Văn thư gốc, chọn trong danh sách đã hoàn tất.",
      "Nhập Người ký và Ngày ký.",
      "Chọn chế độ: Công khai / Riêng tư / Bảo mật.",
      "Bấm Đăng ký.",
    ],
    image: "/huong-dan-van-thu/them-moi.png",
    caption:
      "Màn hình Đăng ký lấy số: ① Nhập tiêu đề, ② Chọn công ty, ③ Chọn loại văn thư, ④ Người cấp số (tự tính theo loại), ⑤ Người ký & ngày ký, ⑥ Trạng thái văn thư, ⑦ Bấm Đăng ký.",
    note: "Nếu người cấp số khác người xin số → trạng thái Chờ cấp số. Nếu người xin số cũng là người cấp số → chuyển thẳng Đã cấp số chờ gửi file Scan.",
  },
  {
    id: "qt4",
    title: "Quy trình 4: Người cấp số duyệt và cấp số",
    intro: "Điều kiện: văn thư đang ở trạng thái 1 (Chờ cấp số) và bạn là người được phân công cấp số.",
    links: [],
    steps: [
      "Mở chi tiết văn thư.",
      "Kiểm tra nội dung, loại văn thư, công ty, người ký, ngày ký.",
      "Xem Số gần đây nhất và Các số đã cấp (nếu hiển thị).",
      "Nếu chưa có số, nhập Số văn thư.",
      "Bấm Chấp thuận → chuyển sang trạng thái 2 (Đã cấp số chờ gửi file Scan).",
      "Hoặc: nhập Lý do từ chối rồi bấm Từ chối duyệt → chuyển sang trạng thái 6.",
    ],
  },
  {
    id: "qt5",
    title: "Quy trình 5: Người xin số upload file scan",
    intro: "Điều kiện: văn thư đang ở trạng thái 2, hoặc đang bị từ chối file/cấp số và cần gửi lại.",
    links: [],
    steps: [
      "Mở chi tiết văn thư.",
      "Ở khu vực File scan đính kèm, bấm Tải lên.",
      "Chọn file scan định dạng PDF.",
      "Nếu cần ẩn file scan với người cấp số: chọn Không cho người cấp số xem file scan và nhập lý do.",
      "Bấm Lưu lại.",
    ],
    note: "Sau khi lưu file scan hợp lệ, văn thư chuyển sang trạng thái 3 (Đã gửi file scan chờ phê duyệt).",
  },
  {
    id: "qt6",
    title: "Quy trình 6: Người cấp số duyệt file scan và hoàn tất",
    intro: "Điều kiện: văn thư đang ở trạng thái 3 và bạn là người cấp số.",
    links: [],
    steps: [
      "Mở chi tiết văn thư.",
      "Kiểm tra file scan đã upload.",
      "Bấm Chấp thuận → chuyển sang trạng thái 4 (Hoàn tất việc cấp số).",
      "Hoặc: nhập Lý do từ chối rồi bấm Từ chối → chuyển sang trạng thái 7.",
    ],
  },
  {
    id: "qt7",
    title: "Quy trình 7: Xử lý văn thư bị từ chối",
    intro: "Có 3 nhóm từ chối chính, người xin số xử lý tiếp:",
    links: [],
    steps: [
      "Trạng thái 5 (Quản lý từ chối duyệt): chỉnh sửa thông tin, lưu lại để gửi về trạng thái 0.",
      "Trạng thái 6 (Bị từ chối cấp số): chỉnh sửa thông tin, lưu lại để gửi về trạng thái 1.",
      "Trạng thái 7 (File scan bị từ chối): upload lại file scan, lưu lại để gửi về trạng thái 3.",
    ],
    note: "Hệ thống hiển thị lý do từ chối ở từng trạng thái. Khi gửi lại thành công, lý do từ chối cũ sẽ được xoá.",
  },
  {
    id: "qt8",
    title: "Quy trình 8: Quản lý tiếp cận văn thư riêng tư",
    intro: "Dùng khi văn thư đã hoàn tất và ở chế độ Riêng tư.",
    links: [],
    steps: [
      "Chủ văn thư: mở chi tiết văn thư đã hoàn tất, chọn nhân sự cần cấp quyền, chọn ngày hết hạn (nếu cần), bấm thêm thành viên. Có thể xoá thành viên khỏi danh sách.",
      "Người chưa có quyền: mở chi tiết văn thư riêng tư đã hoàn tất, bấm Yêu cầu tiếp cận, chờ chủ văn thư phê duyệt.",
      "Chủ văn thư khi có yêu cầu: mở chi tiết, xem danh sách yêu cầu, chọn ngày hết hạn (nếu cần), chấp thuận hoặc từ chối.",
    ],
  },
  {
    id: "qt9",
    title: "Quy trình 9: Lọc và theo dõi danh sách văn thư",
    intro: "Trang danh sách hỗ trợ lọc theo: Tiêu đề, Loại văn thư, Trạng thái, Người đề nghị, Khoảng thời gian.",
    links: [{ label: "Danh sách văn thư", to: "/van-thu" }],
    steps: [
      "Phần thống kê nhanh ở đầu trang: Tổng số văn thư, Đã hoàn thành, Chưa hoàn thành, Bị từ chối, Chờ tôi cấp số, Chờ tôi phê duyệt, Chờ tôi gửi file scan.",
      "Bấm vào số thống kê cần xử lý → danh sách tự lọc theo bạn và trạng thái tương ứng.",
      "Cột chính: Người tạo, Tiêu đề, Loại văn thư, Số văn thư, Người phê duyệt/cấp số, Trạng thái, Ngày tạo, Ngày ký, Ngày duyệt.",
    ],
    image: "/huong-dan-van-thu/danh-sach.png",
    caption:
      "Màn hình danh sách văn thư: ① Thống kê nhanh (bấm để lọc theo việc cần xử lý), ② Bộ lọc tìm kiếm, ③ Xuất Excel, ④ Thêm mới, ⑤ Sửa / xoá từng dòng.",
  },
  {
    id: "qt10",
    title: "Quy trình 10: Xuất Excel danh sách văn thư",
    intro: "Xuất toàn bộ danh sách văn thư ra file Excel.",
    links: [{ label: "Xuất Excel", to: "/export-van-thu" }],
    steps: [
      "Vào trang Xuất Excel của văn thư.",
      "Bấm Xuất File.",
      "Khi hệ thống tạo xong link, bấm Tải file Excel.",
    ],
    image: "/huong-dan-van-thu/xuat-excel.png",
    caption: "Màn hình Xuất Excel danh sách văn thư.",
  },
  {
    id: "qt11",
    title: "Quy trình 11: Đổi người xin số hoặc người cấp số",
    intro: "Điều kiện: bạn có quyền đổi người trong chi tiết văn thư.",
    links: [],
    steps: [
      "Mở chi tiết văn thư.",
      "Dùng chức năng đổi người xin số / người cấp số.",
      "Chọn người mới rồi lưu thay đổi.",
    ],
  },
];

export default function HuongDanVanThu() {
  const [open, setOpen] = useState("qt3");

  const toggle = (id) => setOpen(open === id ? "" : id);

  return (
    <AkkhorLayout idrole="dashboard">
      <div className="breadcrumbs-area">
        <ul>
          <li>
            <Link to="/">Trang chủ</Link>
          </li>
          <li>Hướng dẫn nghiệp vụ văn thư</li>
        </ul>
      </div>

      {/* 1. Tổng quan */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <div className="heading-layout1">
            <div className="item-title">
              <h3 className="mb-0">
                <span className="fas fa-book mr-2" style={{ color: "#f0a500" }} />
                Hướng dẫn nghiệp vụ văn thư
              </h3>
            </div>
          </div>
          <p className="mb-2">
            Module <b>Văn thư lưu trữ</b> có vai trò xin số và cấp số, lưu trữ các văn bản ban hành của
            BHS. Trang này tổng hợp toàn bộ chức năng, vai trò, trạng thái và các quy trình nghiệp vụ để
            người dùng tra cứu nhanh.
          </p>
          <p className="mb-0" style={{ color: "#888" }}>
            Trong menu, module nằm ở mục <b>Dịch vụ hành chính</b>.
          </p>
        </div>
      </div>

      {/* 2. Chức năng chính */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-th-large mr-2" style={{ color: "#17a2b8" }} />
            1. Chức năng chính
          </h4>
          <div className="row">
            {chucNang.map((c, i) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div
                  style={{
                    border: "1px solid #eee",
                    borderRadius: 8,
                    padding: "12px 14px",
                    height: "100%",
                  }}
                >
                  <Link to={c.link} style={{ fontWeight: 600, fontSize: 15 }}>
                    <span className="fas fa-arrow-circle-right mr-1" />
                    {c.group}
                  </Link>
                  <div style={{ color: "#777", fontSize: 13, marginTop: 6 }}>{c.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 2. Vai trò nghiệp vụ */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-users mr-2" style={{ color: "#28a745" }} />
            2. Vai trò nghiệp vụ
          </h4>
          <table className="table table-bordered mb-0" style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ width: 240 }}>Vai trò</th>
                <th>Việc thường làm</th>
              </tr>
            </thead>
            <tbody>
              {vaiTro.map((v, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 600 }}>{v.role}</td>
                  <td>{v.work}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 4. Trạng thái văn thư */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-tasks mr-2" style={{ color: "#007bff" }} />
            4. Trạng thái văn thư
          </h4>
          <div className="row">
            {statusList.map((s) => (
              <div className="col-12 col-md-6 col-lg-4 mb-3" key={s.code}>
                <div
                  style={{
                    borderLeft: `4px solid ${s.color}`,
                    background: "#fafafa",
                    borderRadius: 6,
                    padding: "10px 12px",
                    height: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                    <span
                      style={{
                        background: s.color,
                        color: "#fff",
                        borderRadius: "50%",
                        width: 24,
                        height: 24,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        fontWeight: 700,
                        marginRight: 8,
                      }}
                    >
                      {s.code}
                    </span>
                    <span style={{ fontWeight: 600, fontSize: 14 }}>{s.name}</span>
                  </div>
                  <div style={{ color: "#777", fontSize: 12.5 }}>{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="alert"
            style={{ background: "#fff8e1", border: "1px solid #ffe0a3", borderRadius: 6, fontSize: 13 }}
          >
            <span className="fas fa-info-circle mr-1" style={{ color: "#f0a500" }} />
            Khi tạo mới, hệ thống thường đưa văn thư vào trạng thái <b>1 - Chờ cấp số</b>. Nếu người xin
            số cũng là người cấp số, hệ thống đưa thẳng sang <b>2 - Đã cấp số chờ gửi file Scan</b>.
          </div>
        </div>
      </div>

      {/* 5. Các quy trình - accordion */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-list-ol mr-2" style={{ color: "#6f42c1" }} />
            5. Các quy trình nghiệp vụ
          </h4>
          {quyTrinh.map((qt) => {
            const isOpen = open === qt.id;
            return (
              <div
                key={qt.id}
                style={{
                  border: "1px solid #eee",
                  borderRadius: 8,
                  marginBottom: 10,
                  overflow: "hidden",
                }}
              >
                <div
                  onClick={() => toggle(qt.id)}
                  style={{
                    cursor: "pointer",
                    padding: "12px 15px",
                    background: isOpen ? "#f0f4ff" : "#f7f7f7",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: 600,
                  }}
                >
                  <span
                    className={isOpen ? "fas fa-chevron-down mr-2" : "fas fa-chevron-right mr-2"}
                    style={{ color: "#6f42c1", fontSize: 13 }}
                  />
                  {qt.title}
                </div>
                {isOpen && (
                  <div style={{ padding: "14px 18px" }}>
                    <p style={{ color: "#666", fontSize: 13.5 }}>{qt.intro}</p>
                    {qt.links && qt.links.length > 0 && (
                      <div style={{ marginBottom: 10 }}>
                        {qt.links.map((l, i) => (
                          <Link
                            key={i}
                            to={l.to}
                            className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark mr-2"
                            style={{ fontSize: 12.5 }}
                          >
                            <span className="fas fa-external-link-alt mr-1" />
                            {l.label}
                          </Link>
                        ))}
                      </div>
                    )}
                    <ol style={{ paddingLeft: 18, fontSize: 13.5, lineHeight: 1.7 }}>
                      {qt.steps.map((s, i) => (
                        <li key={i}>{s}</li>
                      ))}
                    </ol>
                    {qt.image && (
                      <figure style={{ margin: "12px 0 4px" }}>
                        <a href={qt.image} target="_blank" rel="noopener noreferrer">
                          <img
                            src={qt.image}
                            alt={qt.caption || qt.title}
                            style={{
                              width: "100%",
                              maxWidth: 1000,
                              border: "1px solid #e3e3e3",
                              borderRadius: 8,
                              boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                              display: "block",
                            }}
                          />
                        </a>
                        {qt.caption && (
                          <figcaption
                            style={{ fontSize: 12.5, color: "#888", marginTop: 6, fontStyle: "italic" }}
                          >
                            <span className="fas fa-camera mr-1" />
                            {qt.caption} (Bấm ảnh để xem lớn.)
                          </figcaption>
                        )}
                      </figure>
                    )}
                    {qt.note && (
                      <div
                        style={{
                          background: "#fff8e1",
                          border: "1px solid #ffe0a3",
                          borderRadius: 6,
                          padding: "8px 12px",
                          fontSize: 12.5,
                          color: "#8a6d00",
                          marginTop: 8,
                        }}
                      >
                        <span className="fas fa-lightbulb mr-1" />
                        {qt.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* 6. Biến cấu trúc mã / file */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-code mr-2" style={{ color: "#20c997" }} />
            6. Biến cấu trúc mã / cấu trúc file
          </h4>
          <p style={{ color: "#666", fontSize: 13.5 }}>
            Dùng khi cấu hình loại văn thư (Quy trình 1). Các biến sẽ được thay thế tự động khi cấp số.
          </p>
          <div className="row">
            {bienCauTruc.map((b, i) => (
              <div className="col-6 col-md-4 col-lg-3 mb-2" key={i}>
                <div style={{ border: "1px solid #eee", borderRadius: 6, padding: "8px 10px" }}>
                  <code style={{ fontWeight: 700, color: "#20c997" }}>{b.v}</code>
                  <div style={{ fontSize: 12.5, color: "#777", marginTop: 3 }}>{b.m}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 7. Lưu ý khi sử dụng */}
      <div className="card height-auto mb-3">
        <div className="card-body">
          <h4 className="mb-3">
            <span className="fas fa-info-circle mr-2" style={{ color: "#6c757d" }} />
            7. Lưu ý khi sử dụng
          </h4>
          <ul style={{ fontSize: 13.5, lineHeight: 1.9, color: "#555", marginBottom: 0 }}>
            <li>File scan chỉ nhận định dạng PDF.</li>
            <li>
              Văn thư ở chế độ Riêng tư cần được chia sẻ hoặc gửi yêu cầu tiếp cận trước khi xem.
            </li>
            <li>
              Khi bị từ chối, hãy đọc kỹ lý do từ chối trong chi tiết văn thư trước khi chỉnh sửa và
              gửi lại.
            </li>
          </ul>
        </div>
      </div>
    </AkkhorLayout>
  );
}
